import {TuiLanguageTable} from '@taiga-ui/i18n/interfaces';

export const TUI_DANISH_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: `Show/Hide`,
    paginationTexts: {
        pages: `Pages`,
        linesPerPage: `Lines per page`,
        of: `of`,
    },
};
